import {
  eachDayOfInterval,
  endOfWeek,
  formatDistanceToNow,
  isToday,
  parseISO,
  startOfWeek,
  startOfMonth,
  endOfMonth,
  addMonths,
  addWeeks,
  subMonths,
  subWeeks,
  isSameDay,
  intervalToDuration,
  addDays,
  subDays,
  isWithinInterval,
  isAfter,
  isBefore,
  differenceInCalendarDays,
  isFirstDayOfMonth,
  isLastDayOfMonth,
  addSeconds,
  subSeconds,
  eachMinuteOfInterval,
  Interval,
  DateArg,
  toDate,
  getSeconds,
  getMinutes,
  isSameSecond,
  addMinutes,
  getHours,
  differenceInMinutes,
  subMinutes,
} from 'date-fns'
import { format } from 'date-fns/format'
import { ru } from 'date-fns/locale/ru'

export const formatDate = (date: Date | number | string, str: string) => {
  if (!date) return null
  let normalizedDate: Date = null

  if (typeof date === 'object') normalizedDate = date
  try {
    normalizedDate = new Date(date)
  } catch (err) {
    console.log(err)
    return null
  }

  try {
    return format(normalizedDate, str, { locale: ru })
  } catch {
    console.log('err')
    return null
  }
}

function timeAgo(dateString: string): string {
  const date = parseISO(dateString)
  const now = new Date()
  const diffInMilliseconds = now.getTime() - date.getTime()

  if (Math.abs(diffInMilliseconds) < 1000 || diffInMilliseconds < 0) {
    return 'только что'
  }

  return formatDistanceToNow(date, { addSuffix: true, locale: ru })
}

const eachSecondsOfInterval = (
  interval: Interval<DateArg<Date>, DateArg<Date>>,
  options?: { step?: number }
): Date[] => {
  const stepInSeconds = options?.step ?? 1

  if (stepInSeconds <= 0) {
    throw new RangeError('step must be greater than 0')
  }

  const start = toDate(interval.start)
  const end = toDate(interval.end)

  const startTime = start.getTime()
  const endTime = end.getTime()
  const step = stepInSeconds * 1000

  if (startTime > endTime) return []

  const result: Date[] = []

  for (let time = startTime; time <= endTime; time += step) {
    result.push(new Date(time))
  }

  return result
}

const timeUtils = {
  addMinutes,
  subSeconds,
  addSeconds,
  isLastDayOfMonth,
  isFirstDayOfMonth,
  isWithinInterval,
  isAfter,
  isBefore,
  subDays,
  addDays,
  isSameDay,
  formatDate,
  timeAgo,
  addMonths,
  addWeeks,
  subMonths,
  subWeeks,
  subMinutes,
  startOfMonth,
  endOfMonth,
  startOfWeek,
  endOfWeek,
  eachDayOfInterval,
  eachMinuteOfInterval,
  eachSecondsOfInterval,
  getSeconds,
  isToday,
  intervalToDuration,
  differenceInCalendarDays,
  differenceInMinutes,
  getMinutes,
  getHours,
  isSameSecond,
}

export default timeUtils
